import { render, staticRenderFns } from "./Scene8.vue?vue&type=template&id=d9ab0d28&scoped=true"
import script from "./Scene8.vue?vue&type=script&lang=js"
export * from "./Scene8.vue?vue&type=script&lang=js"
import style0 from "./Scene8.vue?vue&type=style&index=0&id=d9ab0d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ab0d28",
  null
  
)

export default component.exports